module.exports = new __parcel__URL__("squad_rect.fb8bfbf7.png").toString();